import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Axios from 'axios';

import styled from 'styled-components';

import { forceReloadBillingProjectsSearch } from '@hooks/API/Project/UseProject';
import { forceReloadSearchInvoices } from '@hooks/API/UseInvoices';

import FlexContainer from '@components/Gui/FlexContainer';
import { Loading } from '@components/Gui/Loading';
import NwDrawer from '@components/Gui/NwDrawer';
import NwIcon from '@components/Gui/NwIcon';
import CreditNotePage from '@components/InvoicesAndCreditNotes/CreditNotePage/CreditNotePage';
import InvoicePage from '@components/InvoicesAndCreditNotes/InvoicePage/InvoicePage';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Actions = styled(FlexContainer)`
    svg {
        margin-left: 8px;
    }
`;

const InvoiceDrawer = ({ invoiceId, onClose, reloadBillingProjectsSearchOnClose = true }) => {
    const navigate = useNavigate();
    const [showCreditNote, setShowCreditNote] = useState(null);

    const [invoiceType, setInvoiceType] = useState(null);

    useEffect(() => {
        const fetchInvoiceType = async () => {
            const invoiceTypeName = await Axios.get(`/invoices/getType/${invoiceId}`);
            if (invoiceTypeName.includes('Credit')) {
                setInvoiceType('CreditNote');
            } else {
                setInvoiceType('Invoice');
            }
        };
        if (invoiceId) {
            setInvoiceType(null);
            fetchInvoiceType();
        }
    }, [invoiceId]);

    // const handleMoveInvoiceDetails = () => {
    //     navigate(`/invoice/${invoiceId}`)
    // }

    const handleClose = () => {
        forceReloadSearchInvoices();
        if (reloadBillingProjectsSearchOnClose) {
            forceReloadBillingProjectsSearch();
        }
        onClose();
    };

    const onShowCreditNoteDrawer = (creditNoteID) => {
        setShowCreditNote(creditNoteID);
    };

    return (
        <NwDrawer
            width={'90vw'}
            padding="1rem"
            title={
                <FlexContainer justifyContent="space-between">
                    <div>
                        {showCreditNote || invoiceType === 'CreditNote' ? 'Credit Note Details' : 'Invoice Details'}
                    </div>
                    {/* {breakpoints > 3 &&
                        <Actions>
                            <NwIcon icon={byPrefixAndName.fass['expand-wide']} pointer onClick={handleMoveInvoiceDetails} size='lg' />
                        </Actions>
                    } */}
                </FlexContainer>
            }
            onClose={handleClose}
            whiteBg={false}
        >
            {!invoiceType ? (
                <Loading />
            ) : showCreditNote ? (
                <CreditNotePage creditNoteId={showCreditNote} onClose={onClose} inDrawer />
            ) : invoiceType === 'CreditNote' ? (
                <CreditNotePage creditNoteId={invoiceId} onClose={onClose} inDrawer />
            ) : (
                <InvoicePage
                    invoiceId={invoiceId}
                    onClose={onClose}
                    inDrawer
                    onShowCreditNoteDrawer={onShowCreditNoteDrawer}
                />
            )}
        </NwDrawer>
    );
};

export default InvoiceDrawer;
